<div *ngIf="exist;else attente"></div>
<ng-template #attente>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="showTabAlert">
  <app-avt-listes #listeAlectComponen [showFilter]="false" [heightTable]="'400'" [dataSourceBrut]="datasourceAlerte" [displayedColumnsBrut]="columnsAlerte" [listBtn]="listBtnAlerte" (btnTable)="clickBtnHeat($event)"></app-avt-listes>
</div>